<template>
  <div class="com-map">
    <div class="con-province">
      <ul class="city-list" @mouseleave="onProvinceListLeave">
        <li v-for="(item, index) in provinceData" :key="index"
          :class="{ 'province-li--highlight': isListItemHighlighted(item) }" @click="goPage(item)"
          @mouseenter="showCity(item.linkName)">
          {{ item.linkName }}
        </li>
      </ul>
    </div>
    <div class="map-ref" ref="mapRef" style="margin-top: -10px;"></div>
  </div>
</template>

<script>
import { getProvinces } from '@/api/home'
import axios from "axios";
import { ElMessageBox } from "element-plus";
export default {
  name: "ComMap",
  props: {
    hotData: {
      type: Array,
      default: () => [],
    },
    cqData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 图表的实例对象
      chartInstance: null,
      // 中国地图数据
      chinahotData: null,
      heightLightMapIndex: 10, //点击以后需要高亮的省份对应的索引值
      dataIndex: 0,
      mTime: 0,
      menuData: [],
      isShowMenu: false,
      showStartShow: false, // 是否隐藏轮播按钮
      provinceData: [],
      /** 地图悬浮时与之一致的省份文字（存 linkName） */
      highlightedListName: "",
    };
  },
  watch: {
    hotData(val) {
      if (Array.isArray(val)) {
        this.initChart();
      }
    },
  },
  mounted() {
    console.log('this.$echarts', this.$echarts);
    this.chartInstance = this.$echarts.init(this.$refs.mapRef);

    window.addEventListener("resize", this.screenAdapter);

    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.screenAdapter);
    clearInterval(this.mTime);
    if (this.chartInstance) {
      this.chartInstance.off("click");
      this.chartInstance.off("mouseover");
      this.chartInstance.off("globalout");
    }
  },
  methods: {
    goPage(data) {
      sessionStorage.setItem('provinceInfo', JSON.stringify(data))
      console.log('data', data);
      // if (data?.linkName === '西藏') {
      //   ElMessageBox.confirm(
      //     '为持续优化政务服务，如需办理测绘相关业务，请通过西藏政务服务网办理。给大家带来的不便，深表歉意。',
      //     '公告',
      //     {
      //       confirmButtonText: '点击进入西藏政务服务网',
      //       cancelButtonText: '主管部门登录',
      //       distinguishCancelAndClose: true,
      //       closeOnClickModal: false,
      //       closeOnPressEscape: true,
      //       type: 'warning',
      //     }
      //   )
      //     .then(() => {
      //       window.open('https://www.xzzwfw.gov.cn/index/', '_blank')
      //     })
      //     .catch((action) => {
      //       if (action === 'cancel') {
      //         this.$router.push({
      //           path: '/detail'
      //         })
      //       }
      //     })
      //   return
      // }
      if (data.loginUrl?.startsWith('http')) {
        window.open(data.loginUrl)
      } else {
        this.$router.push({
          path: '/detail'
        })
      }
    },
    /** 地图 geo 名称与接口省份项匹配（简称/全称） */
    findProvinceItem(mapName) {
      if (!mapName || !this.provinceData.length) return null;
      const list = this.provinceData;
      let p = list.find((x) => x.linkName === mapName);
      if (p) return p;
      p = list.find((x) => x.areaName === mapName);
      if (p) return p;
      p = list.find(
        (x) =>
          mapName.includes(x.linkName) ||
          (x.linkName && x.linkName.includes(mapName))
      );
      return p || null;
    },
    isListItemHighlighted(item) {
      if (!this.highlightedListName || !item.linkName) return false;
      return item.linkName === this.highlightedListName;
    },
    bindMapEvents() {
      if (!this.chartInstance) return;
      const chart = this.chartInstance;
      chart.off("click");
      chart.off("mouseover");
      chart.off("globalout");

      chart.on("click", (params) => {
        const name = this.resolveXinjiangClickName(params);
        if (!name) return;
        const item = this.findProvinceItem(name);
        if (item) this.goPage(item);
      });

      chart.on("mouseover", (params) => {
        const name = params.name;
        if (!name) return;
        let targetName = name;
        // 处理新疆和新疆兵团的悬浮逻辑
        if (name === "新疆" || name === "新疆兵团") {
          const evt = params?.event?.event;
          const clickX = evt?.zrX ?? evt?.offsetX;
          const clickY = evt?.zrY ?? evt?.offsetY;
          if (typeof clickX === "number" && typeof clickY === "number") {
            const xinjiangPixel = this.chartInstance.convertToPixel({ geoIndex: 0 }, [87.617733, 43.792818]);
            const btPixel = this.chartInstance.convertToPixel({ geoIndex: 0 }, [87.617733, 45.792818]);
            if (Array.isArray(xinjiangPixel) && Array.isArray(btPixel)) {
              const dx1 = clickX - xinjiangPixel[0];
              const dy1 = clickY - xinjiangPixel[1];
              const dXinjiang = Math.sqrt(dx1 * dx1 + dy1 * dy1);

              const dx2 = clickX - btPixel[0];
              const dy2 = clickY - btPixel[1];
              const dBt = Math.sqrt(dx2 * dx2 + dy2 * dy2);

              // 点到哪个中心点更近，就判定为哪个；中心区域默认新疆
              targetName = dBt < dXinjiang ? "新疆兵团" : "新疆";
            }
          }
        }
        const item = this.findProvinceItem(targetName);
        this.highlightedListName = item ? item.linkName : targetName;
        // 高亮目标区域
        this.clearMapVisualOnly();
        this.chartInstance.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          name: targetName
        });
      });

      chart.on("globalout", () => {
        this.highlightedListName = "";
        // 鼠标移出时取消所有高亮
        this.clearMapVisualOnly();
      });

      chart.on("mouseout", (params) => {
        // 鼠标移出时取消高亮
        this.clearMapVisualOnly();
      });
    },
    resolveXinjiangClickName(params) {
      const name = params?.name;
      if (!name) return "";
      // 仅处理重叠区域：新疆 / 新疆兵团
      if (name !== "新疆" && name !== "新疆兵团") return name;
      if (!this.chartInstance) return "新疆";

      const evt = params?.event?.event;
      const clickX = evt?.zrX ?? evt?.offsetX;
      const clickY = evt?.zrY ?? evt?.offsetY;
      if (typeof clickX !== "number" || typeof clickY !== "number") {
        return "新疆";
      }

      const xinjiangPixel = this.chartInstance.convertToPixel({ geoIndex: 0 }, [87.617733, 43.792818]);
      const btPixel = this.chartInstance.convertToPixel({ geoIndex: 0 }, [87.617733, 45.792818]);
      if (!Array.isArray(xinjiangPixel) || !Array.isArray(btPixel)) return "新疆";

      const dx1 = clickX - xinjiangPixel[0];
      const dy1 = clickY - xinjiangPixel[1];
      const dXinjiang = Math.sqrt(dx1 * dx1 + dy1 * dy1);

      const dx2 = clickX - btPixel[0];
      const dy2 = clickY - btPixel[1];
      const dBt = Math.sqrt(dx2 * dx2 + dy2 * dy2);

      // 点到哪个中心点更近，就判定为哪个；中心区域默认新疆
      return dBt < dXinjiang ? "新疆兵团" : "新疆";
    },
    getProvinceList() {
      getProvinces().then(res => {
        if (res.success) {
          const list = Array.isArray(res.data) ? [...res.data] : []
          this.provinceData = list
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 初始化图表的方法
    async initChart() {
      const provinceName = "河南";
      let url = `/static/map/china.json`;
      const { data: res } = await axios.get(url);
      this.chinahotData = res;
      this.getProvinceList()
      this.$echarts.registerMap(provinceName, this.chinahotData);
      // 初始化地图配置项
      this.initMapOtions(provinceName);
      this.screenAdapter();
    },
    /**
     * 初始化地图的初始配置内容
     */
    initMapOtions(mapName) {
      this.chartInstance.setOption({
        geo: {
          type: "map",
          map: mapName,
          top: "center",
          left: "center",
          roam: false, // 是否允许鼠标缩放和平移
          scaleLimit: {
            //所属组件的z分层，z值小的图形会被z值大的图形覆盖
            min: 0.1, //最小的缩放值
            max: 3, //最大的缩放值
          },
          label: {
            normal: {
              show: true,
              fontSize: "12",
              color: "black",
            },
            emphasis: {
              show: true,
              fontSize: "12",
              color: "black",
            },
          },
          itemStyle: {
            normal: {
              borderColor: "rgba(0, 0, 0, 0.2)",
            },
            emphasis: {
              areaColor: "#f2d5ad",
              shadowOffsetX: 1,
              shadowOffsetY: 1,
              borderWidth: 0,
            },
          },
        },
        tooltip: {
          //提示工具，触发时显示详细数据
          trigger: "item",
          axisPointer: {
            type: "line",
            lineStyle: { color: "#333" },
          },
          // 鼠标滑过提示信息
          formatter: (params) => {
            // let tip = this.formatterTip(params);
            // return tip;
          },
        },
        // visualMap: {
        //   orient: "vertical",
        //   //地图图例
        //   show: true,
        //   left: "left",
        //   bottom: "top",
        //   showLabel: true,
        //   textStyle: {
        //     color: "#ffffff",
        //   },
        //   pieces: [
        //     //根据数据大小，各市显示不同颜色
        //     {
        //       gte: 100,
        //       lt: 499,
        //       label: "测绘资质单位数量(100 - 499)",
        //       color: "#b29454",
        //     },
        //     {
        //       gte: 10,
        //       lt: 99,
        //       label: "测绘资质单位数量(10 - 99)",
        //       color: "#c2b495",
        //     },
        //     {
        //       lt: 10,
        //       label: "测绘资质单位数量(<10)",
        //       color: "#d6d2c8",
        //     },
        //   ],
        // },
        series: [
          {
            type: "map",
            coordinateSystem: "geo",
            geoIndex: 0,
            data: this.hotData,
          },
          // {
          //   type: "effectScatter",
          //   coordinateSystem: "geo",
          //   geoIndex: 0,
          //   symbolSize: function (params) {
          //     return (params[2] / 100) * 15 + 5;
          //   },
          //   rippleEffect: {
          //     color: "red",
          //     brushType: "stroke",
          //   },
          //   itemStyle: {
          //     color: "#ff0000",
          //   },
          //   encode: {
          //     tooltip: 2,
          //   },
          //   data: this.cqData,
          // },
        ],
      });
      this.bindMapEvents();
      // this.mapActive(this.hotData, this.chartInstance);
      // this.startShow();
    },
    /**
     * 鼠标移入显示提示信息
     */
    formatterTip(params) {
      console.log("params", params);
      let _d = this.hotData.filter((it) => it.areaName == params.name)[0];
      if (!_d) return `暂未获取到详细数据！`;
      let str = `
      <table class="tooltip-table">
        <theader>
          <tr>
          <th style="text-align:center" colspan="4">${_d.areaName}</th>
          </tr>
        </theader>
      <tr>
          <td class="title">测绘资质单位数量:</td><td colspan="3"> ${_d.unitSumNum
        }家</td>
        </tr>        
        <tr>
          <td class="title">甲级:</td><td>${_d.jjUnitNum
        }家</td><td class="title">乙级:</td><td>${_d.yjUnitNum}家</td>
        </tr>
        <tr>
          <td class="title">测绘作业项目备案数量:</td><td colspan="3">${_d.regionalProject
        }个</td>
        </tr>
        <tr>
          <td class="title">高新技术企业数量:</td><td colspan="3">${_d.techEnterprise || 0
        }家</td>
        </tr>

        <tr>
          <td class="title">测绘作业证持证人员:</td><td colspan="3"> ${_d.personNumber
        }人</td>
        </tr>
      </table>
      `;
      return str;
    },
    /*
     * 地图中市区 单击
     */
    CityClick(e) {
      // 取消高亮显示
      this.chartInstance.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
      });
      // 高亮当前选择的区域
      this.chartInstance.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: e.dataIndex,
      });
    },
    /**
     * 地图自动高亮轮播
     * **/
    mapActive(mapData, myChart) {
      if (!myChart) {
        return;
      }
      myChart.on("mouseover", () => {
        // 停止定时器，清除之前的高亮
        this.stopShow();
        this.mTime = "";
        myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: this.dataIndex - 1,
        });
      });

      // 鼠标划出重新定时器开始
      // myChart.on("mouseout", () => {
      //   this.startShow();
      // });
    },
    startShow() {
      this.showStartShow = false;
      this.clearHighLight();
      const dataLength = this.hotData.length - 1;
      if (this.mTime) {
        clearInterval(this.mTime);
      }
      // 用定时器控制高亮
      this.mTime = setInterval(() => {
        /**
         * 如果dataIndex 为0 ，则需要高亮第一个区，取消高亮的则是最后一个区，
         * 否则的话 dataIndex减1,取消高亮上一个区
         * **/
        const cancelIndex =
          this.dataIndex == 0 ? dataLength : this.dataIndex - 1;
        this.chartInstance.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: cancelIndex,
        });
        // 当前下标高亮
        this.chartInstance.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: this.dataIndex,
        });
        // 与右侧表格互动展示相应数据
        this.$emit("hightLightTableData", this.dataIndex);
        // 展示提示框内容
        this.chartInstance.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: this.dataIndex,
        });
        // 索引值进行自增，为下一轮展示做准备
        this.dataIndex++;
        if (this.dataIndex > dataLength) {
          this.dataIndex = 0;
        }
      }, 3000);
    },
    stopShow() {
      this.showStartShow = true;
      // this.clearHighLight();
      clearInterval(this.mTime);
      this.$emit("clearHightLightTableData");
    },
    // 根据菜单点击展示区域
    showCity(name) {
      this.highlightedListName = name || "";
      this.clearMapVisualOnly();
      if (!this.chartInstance) return;
      this.chartInstance.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        name,
      });
      this.chartInstance.dispatchAction({
        type: "showTip",
        seriesIndex: 0,
        name,
      });
    },
    /** 鼠标移出顶部省份列表时，取消地图高亮与提示 */
    onProvinceListLeave() {
      this.highlightedListName = "";
      this.clearMapVisualOnly();
    },
    /** 仅清除地图 program 高亮与 tooltip */
    clearMapVisualOnly() {
      if (!this.chartInstance) return;
      this.chartInstance.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
      });
      this.chartInstance.dispatchAction({
        type: "hideTip",
      });
    },
    // 清除所有高亮区域
    clearHighLight() {
      this.highlightedListName = "";
      this.clearMapVisualOnly();
    },
    changeMenu() {
      this.isShowMenu = true;
    },
    closeMenu() {
      this.isShowMenu = false;
    },
    // 不同分辨率的响应式
    screenAdapter() {
      // 当前比较合适的字体大小

      this.chartInstance.resize();
    },
  },
};
</script>

<style lang="scss" scoped>
.city-menu {
  position: absolute;
  bottom: 2%;
  right: 1%;

  ul {
    position: relative;
    width: 5.8rem;
    overflow: hidden;
    background: rgba($color: #0e1535, $alpha: 0.8);
    padding: 1.875rem 0px 0.625rem 0.5rem;
    border-radius: 4px;

    .close-btn {
      position: absolute;
      right: 0.3125rem;
      top: 0.3125rem;
      font-size: 1.125rem;
      cursor: pointer;
    }

    li {
      float: left;
      text-align: center;
      padding: 8px 10px;
      border: 1px #aaa solid;
      margin-right: 4px;
      margin-bottom: 4px;
      width: 100px;
      overflow: hidden;
      color: #aaa;

      &:hover {
        color: #fff;
        cursor: pointer;
      }
    }
  }
}

.city-menu-icon {
  position: absolute;
  top: 3%;
  left: 1%;
  cursor: pointer;

  a {
    font-size: 14px;
    color: #fff;
    display: inline-block;
    border: 1px solid #fff;
    border-radius: 4px;
    padding: 6px 8px;
    margin-right: 4px;

    &:hover {
      color: rgb(236, 73, 73);
    }
  }
}

.com-map {
  height: 45rem;
  width: 100%;

  .map-ref {
    width: 100%;
    height: 100%;
  }
}

::v-deep .tooltip-table {
  border-collapse: collapse;
  border-radius: 12px;

  th,
  td {
    padding: 8px;
    border: 1px solid #888;
  }

  td.title {
    text-align: right;
  }
}

.con-province {
  box-sizing: border-box;
  max-width: 1166px;
  width: 100%;
  overflow: hidden;
  background-color: #d9e6f4;
  margin: 0 auto;
  padding: 1.625rem 0 0 1.43rem;

  .city-list {

    height: 1.125rem;
    max-width: 1166px;
    width: 100%;


    li {
      float: left;
      width: 4.7rem;
      font-size: 1rem;
      line-height: 1.1rem;
      margin-bottom: 1.43rem;
      font-weight: bold;
      color: #000;
      cursor: pointer;
      white-space: nowrap;

      &:hover,
      &.province-li--highlight {
        text-decoration: underline;
        color: #0050ca;
      }
    }

  }
}

/* 平板：宽度 ≤ 768px */
@media (max-width: 400px) {
  .com-map {
    height: 5rem;

    .map-ref {
      display: none;
    }
  }
}
</style>
